import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=23dc744e&scoped=true"
import script from "./ProcessItem.ts?vue&type=script&lang=ts&external"
export * from "./ProcessItem.ts?vue&type=script&lang=ts&external"
import style0 from "./ProcessItem.vue?vue&type=style&index=0&id=23dc744e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc744e",
  null
  
)

export default component.exports